export const MAP_CONFIG = {
  mapTilerKey: "sxBc9HTJDVCkF6E0qOOu",
  useMaptiler: true,
  cluster: {
    radius: 50,
    maxZoom: 14,
    minZoom: 0,
    clusterMaxZoom: 14,
    clusterRadius: 50,
  },
  budapest: {
    center: [19.049435, 47.495777] as [number, number],
    zoom: 13.724794638459691,
  },
  debounceTimeout: 200,
};

export function getInitialMapState() {
  const params = new URLSearchParams(window.location.search);

  const lat = parseFloat(params.get("lat") ?? "");
  const lng = parseFloat(params.get("lng") ?? "");
  const zoom = parseFloat(params.get("zoom") ?? "");

  const hasValidCoords = !isNaN(lat) && !isNaN(lng);
  const hasValidZoom = !isNaN(zoom);

  return {
    center: hasValidCoords
      ? ([lng, lat] as [number, number])
      : MAP_CONFIG.budapest.center,
    zoom: hasValidZoom ? zoom : MAP_CONFIG.budapest.zoom,
  };
}
